import styled from 'styled-components';
import KitchenSvg from '../../assets/amenities/kitchen.svg';

const KitchenIcon = styled(KitchenSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default KitchenIcon;
